import {
    GET_PRODUCT,
    GET_PRODUCT_DETAIL,
    GET_PRODUCT_IMAGE_DETAIL,
    GET_PRODUCT_RELATED,
    SEARCH_PRODUCTS,
    GET_PRODUCTS_BEST_SELLER,
    CLEAR_PRODUCT_DETAIL,
    CHECK_STOCK_PRODUCT,
    GET_PRODUCTS_RATING,
    UPDATE_PRODUCTS_RATING,
    GET_PRODUCTS_INTEREST,
    UPDATE_PRODUCT,
    CREATE_PRODUCT,
    DELETE_PRODUCT,
    GET_CATEGORIES,
  } from "../actions/types";
  
  export default function (state = {}, action) {
    switch (action.type) {
        case GET_PRODUCT:
            return { ...state, product: action.payload };
        case GET_PRODUCT_DETAIL:
            return { ...state, productDetail: action.payload };
        case GET_PRODUCT_IMAGE_DETAIL:
            return { ...state, productImageDetail: action.payload };
        case GET_PRODUCT_RELATED:
            return { ...state, productRelated: action.payload };
        case SEARCH_PRODUCTS:
            return { ...state, productSearch: action.payload };
        case GET_PRODUCTS_BEST_SELLER:
            return { ...state, productBestSeller: action.payload };
        case GET_PRODUCTS_INTEREST:
            return { ...state, productInterest: action.payload };
        case CHECK_STOCK_PRODUCT:
            return { ...state, productChecked: action.payload };
        case GET_PRODUCTS_RATING:
            return { ...state, productRating: action.payload };
        case UPDATE_PRODUCTS_RATING:
            return { ...state, result: action.payload };
        case GET_CATEGORIES:
            return { ...state, categories: action.payload };
        case CLEAR_PRODUCT_DETAIL:
            return { ...state, productDetail: action.payload };
        case UPDATE_PRODUCT:
            return { ...state, result: action.payload };
        case CREATE_PRODUCT:
            return { ...state, result: action.payload };
        case DELETE_PRODUCT:
            return { ...state, result: action.payload };
        default:
            return state;
    }
  }
  